import React, { useEffect, useState, useRef } from "react";
import Button from "../components/Buttons";
import {
  BookingFooter,
  BuyCart,
  AmusementParkImage,
  cartBg,
  EventBg,
} from "../assets/images";
import { BackArrow, BackButton } from "../assets/icons";
import CalendarPicker from "../components/Calendar";
import { styled } from "styled-components";
import BreadCrumb from "../components/Booking/BreadCrumb";
import MobileCarousel from "../components/Booking/MobileCarousel";
import Footer, { FooterMobile } from "../components/Footer";

import { Colors } from "../ColorConstants";
import { fetchAllParks, fetchProductsOfParks } from "../services/parksServices";
import ImageSlide from "../components/Booking/ImageSlide";
import LocationSection from "../components/Booking/Location";
import VisitHours from "../components/Booking/VisitHours";
import FeedbackShare from "../components/Booking/FeedbackShare";
import TicketSelectionGrid from "../components/Booking/TicketSelectionGrid";
import TotalAmountCard from "../components/Booking/TotalAmountCard";
import NoteCard from "../components/Booking/NoteCard";
import {
  useNavigate,
  useParams,
  useSearchParams,
  useLocation,
} from "react-router-dom";
import { getFormattedDate, isValidDate, validateAddToCart } from "../helper";
import { appendCart, clearCart, getCart } from "../services/cartServices";
import { toast } from "react-toastify";
import ErrorCard from "../components/Booking/ErrorCart";

import CustomLoader from "../components/Loader";
import SlotContainer from "../components/Booking/SlotSelection";
import Modal from "react-modal";
import ModalContent from "../components/Booking/ModalContent";

import { OptionCheck } from "../assets/icons";
import { signUpGuest, updateGuestCart } from "../services/guestServices";
import dayjs from "dayjs";
import { trackFBEvent } from "../analytics";
import { EVENT } from "../analytics/constants";
import { WEEK_INDEX } from "../constants";
import ReactGA from "react-ga4";
import { Text } from "../TextConstants";
import { getSettings } from "../services/settingsService";
import SpecialInfo from "../components/Booking/SpecialInfo";

const Booking = () => {
  const [data, setData] = useState({});
  const [products, setProducts] = useState({});
  const [activeImgIndex, setActiveImage] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [cartHasItem, setCartStatus] = useState(0);
  const isUAT =
    window.location.hostname.includes("uat") ||
    window.location.hostname.includes("localhost");
  let id = isUAT ? "635634bc7aafee47dc652cdb" : "63671cce7024902b00cf36af";
  const navigate = useNavigate();

  const [date, setDate] = useState("");
  const [vibrate, setVibration] = useState(false);
  const [error, setError] = useState({
    date: "",
    slot: "",
    products: "",
  });
  const calenderRef = useRef(null);
  const cardRef = useRef(null);
  const slotRef = useRef(null);
  const imgRef = useRef(null);
  const [optionDisplay, setOptionDisplay] = useState(true);
  const [selectedSlot, setSelectedSlot] = useState("");
  const [loading, setLoading] = useState(false);
  const [lwwSettings, setLWWSettings] = useState({});
  let [searchParams] = useSearchParams();
  let promo = searchParams.get("promo");
  let bookingDate = searchParams.get("date");
  let token = localStorage.getItem("token");
  let userType = localStorage.getItem("type");
  let cartId = localStorage.getItem("cartId");
  let shouldContinue = localStorage.getItem("shouldContinue");

  const location = useLocation();
  const dateFromPreviousScreen = location.state?.date;

  const scrollToCalender = () => {
    calenderRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };
  const scrollToCard = (block) => {
    cardRef.current?.scrollIntoView({
      behavior: "smooth",
      block: block,
    });
  };
  const scrollToSlot = () => {
    slotRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };
  useEffect(() => {
    imgRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
    // scrollToCard("start");
    const type = localStorage.getItem("type");
    const shouldCallGuestApi = type === null || type === "guest";
    fetchSettings();
    if (shouldCallGuestApi) {
      fetchSignUpData();
    }
  }, []);

  useEffect(() => {
    const apiToken = localStorage.getItem("token");
    if (apiToken) {
      fetchCart();
    } else {
      fetchData("");
      if (bookingDate && isValidDate(bookingDate)) {
        setDate(new Date(bookingDate));
      } else {
        setDate(new Date());
      }
    }
  }, []);

  useEffect(() => {
    trackFBEvent(EVENT.CURRENT_SCREEN, { page: "Booking Page" });
    if (cartId) {
      addCart();
    }
  }, []);

  // setTimeout(() => {
  //   imgRef.current?.scrollIntoView({
  //     behavior: "smooth",
  //     block: "start",
  //   });
  // }, 0);

  const addCart = async () => {
    try {
      let res = await updateGuestCart(cartId);
      if (shouldContinue === "accept") {
        navigate(`/app/checkout`);
      }
    } catch (err) {
      toast.error(err?.message);
      localStorage.removeItem("cartId");
    }
  };

  const fetchSettings = async () => {
    let settings = await getSettings();
    setLWWSettings(settings?.data?.data?.lww_settings);
  };

  const handleBookTickets = () => {
    calenderRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const fetchCart = async () => {
    try {
      let res = await getCart("");
      const isEmptyObject = Object.keys(res.data.data).length === 0;
      setCartStatus(res?.data?.data?.items?.length || 0);
      // console.log(data.shortName);
      let date =
        res?.data?.data?.outletId === id
          ? res?.data?.data?.bookingDate
            ? new Date(res?.data?.data?.bookingDate)
            : bookingDate && isValidDate(bookingDate)
            ? new Date(bookingDate)
            : new Date()
          : bookingDate && isValidDate(bookingDate)
          ? new Date(bookingDate)
          : new Date();
      setDate(date);
      fetchData(date);
    } catch (err) {
      toast.error(err.message);
    }
  };

  const fetchSignUpData = async () => {
    setLoading(true);
    try {
      let guestId = localStorage.getItem("guestId");
      let guestSigned = localStorage.getItem("guestSigned");
      if (guestSigned !== "yes") {
        let res = await signUpGuest(guestId || "");
        localStorage.setItem("token", res?.data?.data?.token);
        localStorage.setItem("type", res?.data?.data?.type);
        localStorage.setItem("guestId", res?.data?.data?._id);
      }
    } catch (err) {
      toast.error("Error while fetching data");
    }
    setLoading(false);
  };

  const fetchData = async (date) => {
    try {
      let res = await fetchAllParks();
      let data = res?.data?.data.filter((item) => item._id === id)[0];
      setData(data);
      let products = await fetchProductsOfParks(
        data?.shortName ?? "winter",
        dateFromPreviousScreen ??
          dayjs(
            date === ""
              ? bookingDate && isValidDate(bookingDate)
                ? new Date(bookingDate)
                : new Date()
              : date
          ).format("YYYY-MM-DD")
      );
      setProducts(products?.data?.data.map((v) => ({ ...v, count: 0 })));
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleAdd = (id) => {
    setVibration(false);
    let productArray = [...products];
    let index = productArray.findIndex((x) => x._id === id);
    productArray[index].count = productArray[index].count + 1;
    setProducts(productArray);
    setError({ ...error, products: "" });
  };
  const handleSubtract = (id) => {
    setVibration(false);
    let productArray = [...products];
    let index = productArray.findIndex((x) => x._id === id);
    if (productArray[index].count > 0) {
      productArray[index].count = productArray[index].count - 1;
    }
    setProducts(productArray);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleContinue = async () => {
    let response = await clearCart();
    if (response.status === 201) {
      handleAddToCart();
    }
  };

  const getAmount = (prod) => {
    var result = prod?.reduce(function (acc, obj) {
      return acc + obj.price * obj.count;
    }, 0);
    return result;
  };

  const handleAddToCart = async () => {
    let error = validateAddToCart(products, date, selectedSlot);
    setError(error);
    if (!error.date && !error.products) {
      setLoading(true);
      let filteredItems = [...products].filter((item) => item.count > 0);
      let payloadArray = [...filteredItems].map((item) => {
        return {
          productId: item._id,
          qty: item.count,
          date: getFormattedDate(date),
        };
      });
      let payload = { items: [...payloadArray] };

      try {
        const type = localStorage.getItem("type");
        const isUAT =
          window.location.hostname.includes("uat") ||
          window.location.hostname.includes("localhost");
        let res = await getCart("");
        if (res.status === 201) {
          const isEmptyObject = Object.keys(res.data.data).length === 0;
          setCartStatus(res?.data?.data?.items?.length || 0);
          let isSameDate =
            res?.data?.data?.bookingDate === getFormattedDate(date);
          let isSameOutlet =
            res?.data?.data?.outletId === products[0]?.outletId;
          if (isEmptyObject || (isSameOutlet && isSameDate)) {
            let res = await appendCart(payload);
            if (res.status === 201) {
              trackFBEvent(EVENT.ADD_TO_CART, { park: data?.name });
              if (!isUAT) {
                ReactGA.event({
                  category: "Custom Events",
                  action: `${data?.name} Cart`,
                  label: `${data?.name} Cart of ${type} `,
                });
              }
              if (promo) {
                navigate(`/app/cart?spinpromo=${promo}`);
              } else {
                navigate(`/app/cart`, {
                  state: { date: getFormattedDate(date) },
                });
              }
            }
          } else {
            setIsModalOpen(true);
          }
        }
      } catch (err) {
        toast.error(err?.message, { hideProgressBar: true });
      }
      setLoading(false);
    } else {
      if (error.date) {
        scrollToCalender();
      } else {
        if (error.slot) {
          scrollToSlot("center");
        } else {
          if (error.products) {
            scrollToCard();
            setVibration(true);
          }
        }
      }
    }
  };

  const handleSelectDate = (date) => {
    setError({ ...error, date: "" });
    setDate(date);
    fetchData(date);
  };

  const handleImageSelect = (index) => {
    setActiveImage(index);
  };

  const closeDropdown = () => {
    // console.log(optionDisplay);
    if (optionDisplay === false) {
      setOptionDisplay(!optionDisplay);
    }
  };
  const getBreadCrumbData = () => {
    return [
      { label: "Home", path: `/auth/home` },
      {
        label: "Booking",
        path: ``,
      },
      {
        label: data?.name,
        path: ``,
      },
    ];
  };
  const toggle = () => {
    const newValue = !optionDisplay;
    setOptionDisplay(newValue);
  };
  const setSlot = (value) => {
    setError({ ...error, slot: "" });
    setSelectedSlot(value);
  };

  const filterDates = (date) => {
    let d = new Date(date);
    let day = d.getDay();
    let dayString = WEEK_INDEX[day];
    let isWeekDayEnabled = true;
    if (data?.bookingWeekDays && data?.bookingWeekDays?.length > 0) {
      isWeekDayEnabled = data.bookingWeekDays?.indexOf(dayString) >= 0;
    } else {
      isWeekDayEnabled = true;
    }
    if (data?.shortName === "winter") {
      let formattedDate = getFormattedDate(date);
      let bookingNotAllowed = [...lwwSettings.booking_not_allowed_date];
      let bookingAllowed = [...lwwSettings.booking_allowed_on_holiday];
      let isAllowedDate = bookingAllowed.includes(formattedDate);
      let isNotAllowedDate = bookingNotAllowed.includes(formattedDate);
      if (isAllowedDate) return true;
      if (isNotAllowedDate) return false;
      return isWeekDayEnabled;
    } else {
      return isWeekDayEnabled;
    }
  };

  const contactInfo = {
    email: data?.email,
    phone: data?.phone,
    actualRating: data?.actualRating,
    totalRating: data?.totalRating,
  };
  return (
    <div onClick={closeDropdown} ref={imgRef}>
      {/* <BackImageContainer onClick={() => navigate(`/auth/home`)}>
        <BackImage src={BackButton} />
      </BackImageContainer> */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Modal confirmation"
        style={{
          content: {
            height: "20rem",
            maxWidth: "25rem",
            margin: "auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          },
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            zIndex: 999,
          },
        }}
      >
        <ModalContent closeModal={closeModal} handleContinue={handleContinue} />
      </Modal>

      <MobileCarousel
        images={data?.images}
        cartHasItem={cartHasItem}
        userType={userType}
        navigate={navigate}
      />
      {/* <BannerContainer>
        {data?.images?.length > 0 && <img src={AmusementParkImage} />}
        <Overlay></Overlay>
      </BannerContainer> */}
      {/* <BreadCrumb
        items={getBreadCrumbData()}
        activeItem={data?.name}
        isButton={false}
      /> */}
      <BannerContainer>
        <img src={EventBg} />
        <Overlay>
          <div>
            {/* <Logo src={require("../assets/images/lww_logo.png")} alt="logo" /> */}
          </div>
          <div style={{ paddingTop: "1rem", display: "flex", gap: "0.5rem" }}>
            {cartHasItem > 0 && (
              <div>
                <Button
                  onClick={() => navigate("/app/cart")}
                  label={`My Cart (${cartHasItem})`}
                  variant="filled"
                  backgroundColor={Colors.white}
                  hoverColor={Colors.aqua}
                  hoverFontColor={Colors.white}
                  fontColor={Colors.aqua}
                  outlineColor={Colors.white}
                  borderRadius="2rem"
                  width="10rem"
                />
              </div>
            )}
            <div>
              {["guest"].includes(userType) ? (
                <Button
                  onClick={() => navigate("/auth/login")}
                  label={"Sign In"}
                  variant="filled"
                  backgroundColor={Colors.white}
                  hoverColor={Colors.aqua}
                  hoverFontColor={Colors.white}
                  fontColor={Colors.aqua}
                  outlineColor={Colors.white}
                  borderRadius="2rem"
                />
              ) : (
                <Button
                  onClick={() => {
                    navigate("/auth/login");
                    localStorage.removeItem("token");
                    localStorage.removeItem("user");
                    localStorage.removeItem("type");
                    localStorage.removeItem("name");
                    localStorage.removeItem("refreshToken");
                    localStorage.removeItem("guestSigned");
                  }}
                  label={"Sign Out"}
                  variant="filled"
                  backgroundColor={Colors.white}
                  hoverColor={Colors.aqua}
                  hoverFontColor={Colors.white}
                  fontColor={Colors.aqua}
                  outlineColor={Colors.white}
                  borderRadius="2rem"
                />
              )}
            </div>
          </div>
        </Overlay>
      </BannerContainer>
      <BookingPageContainer>
        <BookingDetailsContainer>
          <BookingDetailsSubContainer>
            <ParkNameContainer>
              <ParkName>{Text.tickets}</ParkName>
              {/* <FeedbackShare
                email={data?.email}
                phone={data?.phone}
                rating={data?.actualRating}
                totalRating={data?.totalRating}
              /> */}
            </ParkNameContainer>
            <ImageSlide
              imageArray={data?.images}
              activeImgIndex={activeImgIndex}
              onImageSelect={handleImageSelect}
            />
            <ParksDetail>
              <ParkDescription>{data?.description}</ParkDescription>
              <VisitHours visitHours={data?.visitingHoursOrderBy || []} />

              <LocationSection location={data?.address} />
              {data?.specialInfo && <SpecialInfo info={data?.specialInfo} />}
            </ParksDetail>
          </BookingDetailsSubContainer>

          <ParkDetailsContainer>
            <ParksDetailMobile>
              <ParksInfoContainer>
                <ParkName>{Text.tickets}</ParkName>
                <ParkInfoSubContainer>
                  <Button
                    variant="filled"
                    // endIcon={<BuyIcon src={BuyCart} />}
                    label="Book Tickets"
                    padding="0.35rem 1rem"
                    width="100%"
                    onClick={handleBookTickets}
                  />
                  <FeedbackSpace>
                    <FeedbackShare
                      email={data?.email}
                      phone={data?.phone}
                      rating={data?.actualRating}
                      totalRating={data?.totalRating}
                    />
                  </FeedbackSpace>
                </ParkInfoSubContainer>
              </ParksInfoContainer>
              <ParkDescription>{data?.description}</ParkDescription>

              <VisitHours
                visitHours={data?.visitingHoursOrderBy || []}
                contactInfo={contactInfo || []}
              />

              <LocationSection location={data?.address} />
              {data?.specialInfo && <SpecialInfo info={data?.specialInfo} />}
            </ParksDetailMobile>
            <div ref={calenderRef}>
              <CalendarPicker
                onSetDate={handleSelectDate}
                date={date}
                error={error.date}
                minDate={new Date()}
                filterDate={filterDates}
                // showHelper={data.shortName === "winter" ? false : true}
              />
            </div>
            {/* <SlotContainer ref={slotRef}>
              <Title>{Text.slotSelectionTitle}</Title>
              <SlotSelectContainer>
                <SelectedSlot onClick={toggle}>
                  {selectedSlot}
                  <OptionContainer disabled={optionDisplay}>
                    <Option
                      onClick={() => setSlot(slots[0])}
                      selected={selectedSlot === slots[0]}
                    >
                      {slots[0]}
                      <Tick selected={selectedSlot === slots[0]}></Tick>
                    </Option>
                    <Option
                      onClick={() => setSlot(slots[1])}
                      selected={selectedSlot === slots[1]}
                    >
                      {slots[1]}
                      <Tick selected={selectedSlot === slots[1]}></Tick>
                    </Option>
                    <Option
                      onClick={() => setSlot(slots[2])}
                      selected={selectedSlot === slots[2]}
                    >
                      {slots[2]}
                      <Tick selected={selectedSlot === slots[2]}></Tick>
                    </Option>
                  </OptionContainer>
                </SelectedSlot>
              </SlotSelectContainer>
              {error.slot && <ErrorHelperText>{error.slot}</ErrorHelperText>}
            </SlotContainer> */}
            <div ref={cardRef}>
              <TicketSelectionGrid
                vibration={vibrate}
                products={products}
                onSubtract={handleSubtract}
                onAdd={handleAdd}
                isLww={data?.shortName === "winter"}
              />
            </div>
            <TotalAmountCard
              amount={products.length > 0 && getAmount(products)}
            />
            <NoteCard data={data} />
            <Button
              variant="filled"
              endIcon={<BuyIcon src={BuyCart} />}
              label="Add to Cart"
              onClick={handleAddToCart}
            />
            {/* {data?.shortName === "winter" && (
              <TermsCondition target="_blank" href="https://lusailwinterwonderland.info/terms-and-conditions/">{Text.termsConditions}</TermsCondition>
            )} */}
            <ErrorCard errorObj={error} />
          </ParkDetailsContainer>
        </BookingDetailsContainer>
      </BookingPageContainer>
      {/* <BookingFooterContainer /> */}
      {/* <FooterContainer>
        <Footer />
      </FooterContainer> */}
      {/* <FooterMobile /> */}
      {loading ? <CustomLoader /> : <></>}
    </div>
  );
};

const BackImageContainer = styled.div`
  @media only screen and (max-width: 576px) {
    display: flex;
    position: fixed;
    top: 2rem;
    margin: 0 0 0 0.5rem;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 0.5rem;
    z-index: 1000;
  }
  @media only screen and (min-width: 577px) {
    display: none;
  }
`;
const BackImage = styled.img`
  width: 0.6rem;
  height: 0.8rem;
  padding: 0.8rem;
  resize-mode: contain;
`;

const BannerContainer = styled.div`
  // height: 30rem;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  > img {
    //  height: 30rem;

    width: 100%;
    object-fit: contain;
  }
  @media only screen and (max-width: 1024px) {
    display: none;
  }
`;
const Overlay = styled.div`
  position: absolute;
  // background-color: #0000005d;
  height: 10rem;
  width: 80%;
  display: flex;
  justify-content: space-between;
  align-items: start;

  top: 0;
  @media only screen and (max-width: 768px) {
    width: 90%;
  }
`;

const BookingFooterContainer = styled.div`
  height: 5rem;
  background: url(${BookingFooter});
  background-size: contain;
  margin-top: 4rem;
`;
const BuyIcon = styled.img`
  width: 2rem;
  height: 2rem;
`;

const ParkName = styled.div`
  font-size: 2.5rem;
  font-weight: 700;
  width: 60%;
  color: ${Colors.aqua};
  @media only screen and (max-width: 1024px) {
    font-size: 2rem;
    font-weight: 700;
  }
  @media only screen and (max-width: 375px) {
    width: 55%;
  }
`;
const ParkDescription = styled.div`
  font-size: 0.9rem;
  font-weight: 400;
  text-align: justify;
  // margin-top: 0.5rem;
  line-height: 1.3rem;
  color: ${Colors.lwwTextColor};
`;

const BookingPageContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 4rem;
  padding-bottom: 4rem;
  @media only screen and (max-width: 1024px) {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
`;
const BookingDetailsContainer = styled.div`
  width: 1024px;
  gap: 4rem;
  display: flex;
`;

const BookingDetailsSubContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  gap: 1.5rem;
  @media only screen and (max-width: 1024px) {
    display: none;
  }
`;
const ParkNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  // margin-top: -0.8rem;
  @media only screen and (max-width: 1024px) {
    display: none;
  }
`;

const ParksDetail = styled.div`
  display: flex;
  flex-direction: column;
  overflow: overflow;
  @media only screen and (max-width: 1024px) {
    display: none;
  }
`;

const ParksDetailMobile = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 0.6rem;
  width: 100%;
  @media only screen and (min-width: 1024px) {
    display: none;
  }
`;
const ParksInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  // border: 1px solid red;
  align-items: center;
  gap: 0.5rem;
`;

const ParkInfoSubContainer = styled.div`
  display: flex;
  flex-direction: column;
  // border: 1px solid red;
  // width: 50%;
  height: 100%;
  align-items: flex-end;
  // gap: 1rem;
  margin-top: 0.6rem;
`;

const FeedbackSpace = styled.div`
  display: flex;
  width: 100%;
  height: 40%;
  align-items: center;
  justify-content: flex-end;
  margin-top: 0.6rem;
  @media only screen and (max-width: 1024px) {
    display: none;
  }
`;

const ParkDetailsContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  @media only screen and (max-width: 1024px) {
    width: 100%;
    padding: 0 1rem;
  }
`;
const TermsCondition = styled.a`
  display: flex;
  align-self: center;
  color: ${Colors.aqua};
  font-size: 1rem;
  font-weight: 500;
  text-decoration-line: underline;
  @media only screen and (max-width: 1024px) {
    font-size: 1rem;
  }
`;

const FooterContainer = styled.div`
  @media only screen and (max-width: 576px) {
    display: none;
  }
`;

const Title = styled.div`
  color: ${Colors.black};
  font-family: Poppins;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 700;
`;

const SlotSelectContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: flex-end;
  position: relative;
  width: 100%;
  position: relative;
`;
const SelectedSlot = styled.div`
  position: relative;
  border-bottom: 1px solid ${Colors.grey40};
  border-top: none;
  border-left: none;
  border-right: none;
  height: 2rem;
  width: 100%;
  outline: none;
  background: none;
  color: ${Colors.black};
  font-family: Poppins;
  font-size: 1rem;
  font-style: normal;

  &::placeholder {
    color: ${Colors.lightBlack};
    font-weight: 500;
  }
`;

const OptionContainer = styled.div`
  position: absolute;
  top: 40px;
  border-radius: 10px;
  background: #efefef;
  display: ${(props) => (props.disabled === true ? "none" : "flex")};
  flex-direction: column;
  z-index: 99;
  width: 100%;
  height: 150px;
  justify-content: space-between;
`;

const Option = styled.div`
  flex-grow: 1;
  padding: 0px 16px;
  font-size: 16px;
  font-style: normal;
  font-weight: ${(props) => (props.selected === true ? "700" : "500")};
  line-height: 22px;
  display: flex;
  align-items: center;
`;

const Tick = styled.div`
  display: ${(props) => (props.selected === true ? "inline-block" : "none")};
  background-image: url(${OptionCheck});
  width: 24px;
  height: 24px;
  margin-left: 16px;
`;
const ErrorHelperText = styled.div`
  font-size: 0.75rem;
  color: red;
`;

const Logo = styled.img`
  width: 22rem;
  resize: contain;

  @media only screen and (max-width: 768px) {
    width: 14rem;
  }
`;

export default Booking;
